
















import { Component, Vue, Prop } from "vue-property-decorator";
import { FormFieldProps, FormFieldRules, IFormField, EnumDTO } from "../../Models/Components.model";
import ButtonList from "../Common/Buttons/ButtonList.vue";
import ParticaBaseForm from "../Base/ParticaBaseForm.vue";
import { ContentStreamIssueDTO } from "../../Generated/ParticaAPI";

@Component(
	{
		name: "ContentStreamIssueForm",
		components: { ButtonList }
	})
export default class ContentStreamIssueForm extends ParticaBaseForm<ContentStreamIssueDTO> {

	private nameconfig =
		{
			props: { name: "name", placeholder: "Enter name for the new issue", label: "Issue Name", } as FormFieldProps,
			rules: { required: true, max: 200, min: 0, } as FormFieldRules
		} as IFormField;

}
